import request from '@/router/axios';


export function uploadFile(data) {
  return request({
    url: "/sys/uploadFileToQiniu",
    method: 'POST',
    data: data
  });
}

export function downloadQiniuFile(data) {
  return request({
    url: "/sys/downloadQiniuFile",
    method: 'POST',
    data: data,
    responseType: 'arraybuffer',
  });
}

export function queryAttachByIds(data) {
  return request({
    url: "/sys/queryAttachByIds",
    method: 'POST',
    data: data
  });
}
